module.exports = __webpack_public_path__ + "static/media/orochi_color.407f2ef4.png";